/**
 * Breakpoint definitions for the theme
 * Used by both Tailwind and JavaScript
 * 
 * @typedef {Object} Breakpoints
 * @property {string} sm - Small breakpoint (782px - matches WordPress admin breakpoint)
 * @property {string} md - Medium breakpoint (960px)
 * @property {string} lg - Large breakpoint (1080px)
 * @property {string} xl - Extra large breakpoint (1280px)
 * @property {string} 2xl - 2x Extra large breakpoint (1440px)
 * @property {string} 3xl - 3x Extra large breakpoint (1640px)
 */
const breakpoints = {
    sm: "782px",
    md: "960px",
    lg: "1080px",
    xl: "1280px",
    "2xl": "1440px",
    "3xl": "1640px"
};

export { breakpoints };